"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _checkForIds = function checkForIds(values) {
  if (Array.isArray(values)) {
    var isCorrect = values.every(function (item) {
      return _typeof(item) !== 'object' || Object.prototype.hasOwnProperty.call(item, 'id');
    });
    if (!isCorrect) {
      throw new Error('Every array element should have an ID');
    }
    var _iterator = _createForOfIteratorHelper(values),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        _checkForIds(item);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (_typeof(values) === 'object' && values !== null) {
    for (var _i = 0, _Object$values = Object.values(values); _i < _Object$values.length; _i++) {
      var _item = _Object$values[_i];
      _checkForIds(_item);
    }
  }
  return true;
};
var _default = exports["default"] = function _default(values, updatedValues) {
  _checkForIds(updatedValues);
  function composeObject(obj, updatedObj) {
    if (obj.doNotTraverse || updatedObj.doNotTraverse) {
      updatedObj.doNotTraverse = true;
      return;
    }
    var updatedKeys = Object.keys(updatedObj);
    for (var _i2 = 0, _Object$entries = Object.entries(obj); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      if (updatedKeys.includes(key)) {
        traverse(obj[key], updatedObj[key]);
      } else {
        updatedObj[key] = value;
      }
    }
  }
  function traverse(obj, updatedObj) {
    if (!obj) {
      return;
    }
    if (Array.isArray(updatedObj)) {
      if (updatedObj.length === 0 || _typeof(updatedObj[0]) !== 'object') {
        return;
      }
      updatedObj.forEach(function (item) {
        var originalItem = obj.find(function (row) {
          return row.id === item.id;
        });
        if (!originalItem) {
          return;
        }
        composeObject(originalItem, item);
      });
    } else if (_typeof(updatedObj) === 'object' && updatedObj !== null) {
      composeObject(obj, updatedObj);
    }
  }
  var result = (0, _cloneDeep2["default"])(updatedValues);
  traverse(values, result);
  return result;
};